module.exports = "<!-- PRINCIPAIS PROPOSTAS-->\n  <h2 class=\"text-title\">Principais Propostas</h2>\n  <div class=\"row\">\n\n    <div class=\"col-sm-12 col-md-6 card\" *ngFor=\"let item of itens | async\">\n      <div class=\"d-flex w-100 justify-content-between\">\n        <h5 class=\"mb-1\">{{item.titulo}}</h5>\n      </div>\n      <p class=\"mb-1\">{{item.resumo}}</p>\n    </div>\n  </div>\n  <br>\n  <a  class=\"btn btn-outline-primary\" routerLink=\"/propostas\" role=\"button\">Ver Mais</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home-propostas/home-propostas.component.html
// module id = ./src/app/home/home-propostas/home-propostas.component.html
// module chunks = main